(function () {
  'use strict';

  if (window.GdHomeHeroCarousel) {
    window.GdHomeHeroCarousel.initAll(document);
    return;
  }

  var instances = new WeakMap();

  function init(root) {
    if (instances.has(root)) return;
    var track = root.querySelector('[data-home-hero-track]');
    var slides = Array.from(root.querySelectorAll('[data-home-hero-slide]'));
    var controls = root.querySelector('[data-home-hero-controls]');
    var dots = Array.from(root.querySelectorAll('[data-home-hero-dot]'));
    var previous = root.querySelector('[data-home-hero-previous]');
    var next = root.querySelector('[data-home-hero-next]');
    var status = root.querySelector('[data-home-hero-status]');
    if (!track || slides.length < 2 || !controls || !previous || !next) return;

    var active = Math.max(0, Math.min(slides.length - 1, Number(root.dataset.startSlide) || 0));
    var autoplayButton = root.querySelector('[data-home-hero-autoplay]');
    var automatic = root.dataset.autoplay === 'true';
    var editing = Boolean(window.Shopify && window.Shopify.designMode);
    var interval = Math.max(3, Math.min(15, Number(root.dataset.interval) || 7)) * 1000;
    var rotationTimer = 0;
    var hovered = root.matches(':hover');
    var userPaused = false;
    var destroyed = false;
    var scrollAnnouncement = true;
    var frame = 0;
    var settle = 0;
    var resizing = false;
    var abort = new AbortController();
    var options = { signal: abort.signal };
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function positionControls() {
      var desktop = window.innerWidth > 989;
      var anchor;
      if (active === 0) anchor = slides[active].querySelector(desktop ? '.gd-hero__image-col' : '.gd-hero__mobile-image');
      else {
        var campaign = slides[active].querySelector('.gd-home-carousel__campaign');
        anchor = desktop && campaign && campaign.dataset.campaignLayout === 'split' ? campaign.querySelector('.gd-home-carousel__picture') : campaign;
      }
      if (!anchor) return;
      var imageRect = anchor.getBoundingClientRect();
      var rootRect = root.getBoundingClientRect();
      var top = imageRect.bottom - rootRect.top - controls.offsetHeight - 12;
      if (!desktop && active === 1) {
        var content = slides[active].querySelector('.gd-home-carousel__content');
        var firstContent = content && content.firstElementChild;
        if (firstContent) top = firstContent.getBoundingClientRect().top - rootRect.top - controls.offsetHeight - 16;
      }
      var slideOffset = slides[active].getBoundingClientRect().left - track.getBoundingClientRect().left;
      var left = imageRect.left - slideOffset - rootRect.left + imageRect.width / 2;
      root.style.setProperty('--gd-home-controls-top', Math.max(0, Math.round(top)) + 'px');
      root.style.setProperty('--gd-home-controls-left', Math.round(left) + 'px');
      if (!desktop) {
        var photoHeight = active === 0 ? imageRect.height : Math.min(imageRect.width, imageRect.height);
        var photoCenter = imageRect.top - rootRect.top + photoHeight / 2;
        var imageLeft = imageRect.left - slideOffset - rootRect.left;
        root.style.setProperty('--gd-home-mobile-arrow-top', Math.round(photoCenter - Math.max(0, top)) + 'px');
        root.style.setProperty('--gd-home-mobile-arrow-left', Math.round(Math.max(0, imageLeft) + 8) + 'px');
        root.style.setProperty('--gd-home-mobile-arrow-right', Math.round(Math.max(0, rootRect.width - imageLeft - imageRect.width) + 8) + 'px');
      }
    }

    function syncPaletteFromPosition() {
      var width = track.clientWidth;
      if (width <= 0) return;
      var index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
      var value = String(index);
      if (root.dataset.paletteSlide !== value) root.dataset.paletteSlide = value;
    }

    function updateAutoplayButton() {
      if (!autoplayButton) return;
      var paused = userPaused || motion.matches || editing;
      autoplayButton.hidden = !automatic;
      autoplayButton.disabled = editing || motion.matches;
      autoplayButton.dataset.paused = String(paused);
      autoplayButton.setAttribute('aria-label', paused ? autoplayButton.dataset.playLabel : autoplayButton.dataset.pauseLabel);
      var play = autoplayButton.querySelector('[data-autoplay-play]');
      var pause = autoplayButton.querySelector('[data-autoplay-pause]');
      if (play) play.hidden = !paused;
      if (pause) pause.hidden = paused;
    }

    function stopRotation() {
      window.clearTimeout(rotationTimer);
      rotationTimer = 0;
    }

    function scheduleRotation() {
      stopRotation();
      updateAutoplayButton();
      if (destroyed || !automatic || editing || motion.matches || userPaused || hovered || document.hidden || root.contains(document.activeElement)) return;
      rotationTimer = window.setTimeout(function () {
        rotationTimer = 0;
        goTo((active + 1) % slides.length, true, false);
      }, interval);
    }

    function update(index, announce) {
      active = Math.max(0, Math.min(slides.length - 1, index));
      slides.forEach(function (slide, i) {
        var selected = i === active;
        if (!selected && slide.contains(document.activeElement)) {
          track.focus({ preventScroll: true });
        }
        slide.toggleAttribute('inert', !selected);
        slide.setAttribute('aria-hidden', String(!selected));
      });
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === active ? 'true' : 'false');
      });
      previous.disabled = active === 0;
      next.disabled = active === slides.length - 1;
      if (announce && status) status.textContent = slides[active].getAttribute('aria-label');
      positionControls();
    }

    function goTo(index, smooth, announce) {
      scrollAnnouncement = announce !== false;
      update(index, smooth && scrollAnnouncement);
      track.scrollTo({
        left: active * track.clientWidth,
        behavior: smooth && !motion.matches ? 'smooth' : 'instant'
      });
      syncPaletteFromPosition();
      scheduleRotation();
    }

    if (autoplayButton) autoplayButton.addEventListener('click', function () {
      userPaused = !userPaused;
      scheduleRotation();
    }, options);
    root.addEventListener('mouseenter', function () { hovered = true; stopRotation(); }, options);
    root.addEventListener('mouseleave', function () { hovered = false; scheduleRotation(); }, options);
    root.addEventListener('focusin', stopRotation, options);
    root.addEventListener('focusout', function () { queueMicrotask(scheduleRotation); }, options);
    root.addEventListener('pointerdown', stopRotation, { passive: true, signal: abort.signal });
    root.addEventListener('pointerup', scheduleRotation, { passive: true, signal: abort.signal });
    document.addEventListener('visibilitychange', scheduleRotation, options);
    motion.addEventListener('change', scheduleRotation, options);
    root.addEventListener('load', positionControls, { capture: true, signal: abort.signal });

    previous.addEventListener('click', function () { goTo(active - 1, true); }, options);
    next.addEventListener('click', function () { goTo(active + 1, true); }, options);
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () { goTo(index, true); }, options);
    });
    root.addEventListener('keydown', function (event) {
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
      var destination;
      if (event.key === 'ArrowLeft') destination = active - 1;
      else if (event.key === 'ArrowRight') destination = active + 1;
      else if (event.key === 'Home') destination = 0;
      else if (event.key === 'End') destination = slides.length - 1;
      else return;
      event.preventDefault();
      goTo(destination, true);
    }, options);
    if (window.Shopify && window.Shopify.designMode) {
      root.addEventListener('shopify:block:select', function (event) {
        var slide = event.target.closest && event.target.closest('[data-home-hero-slide]');
        var index = slides.indexOf(slide);
        if (index >= 0) goTo(index, false);
      }, options);
    }
    track.addEventListener('scroll', function () {
      syncPaletteFromPosition();
      if (resizing) return;
      stopRotation();
      window.clearTimeout(settle);
      settle = window.setTimeout(function () {
        update(Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)), scrollAnnouncement);
        scrollAnnouncement = true;
        scheduleRotation();
      }, 100);
    }, { passive: true, signal: abort.signal });

    slides.forEach(function (slide) { slide.hidden = false; });
    root.classList.add('gd-home-carousel--ready');
    track.setAttribute('tabindex', '0');
    controls.hidden = false;
    goTo(active, false, false);

    var observedWidth = track.clientWidth;
    var resize = function () {
      var width = track.clientWidth;
      positionControls();
      if (width === observedWidth || width === 0) return;
      observedWidth = width;
      resizing = true;
      window.cancelAnimationFrame(frame);
      window.clearTimeout(settle);
      frame = window.requestAnimationFrame(function () {
        goTo(active, false);
        frame = window.requestAnimationFrame(function () { resizing = false; });
      });
    };
    var observer = typeof ResizeObserver === 'function' ? new ResizeObserver(resize) : null;
    if (observer) { observer.observe(track); observer.observe(root); }
    else window.addEventListener('resize', resize, options);

    instances.set(root, {
      destroy: function () {
        destroyed = true;
        stopRotation();
        abort.abort();
        window.cancelAnimationFrame(frame);
        window.clearTimeout(settle);
        if (observer) observer.disconnect();
        instances.delete(root);
      }
    });
  }

  function initAll(scope) {
    if (scope.matches && scope.matches('[data-gd-home-carousel]')) init(scope);
    scope.querySelectorAll('[data-gd-home-carousel]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var roots = Array.from(event.target.querySelectorAll('[data-gd-home-carousel]'));
    if (event.target.matches && event.target.matches('[data-gd-home-carousel]')) roots.push(event.target);
    roots.forEach(function (root) {
      var instance = instances.get(root);
      if (instance) instance.destroy();
    });
  });
  window.GdHomeHeroCarousel = { initAll: initAll };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else initAll(document);
})();
